import React from 'react';
import { homeStats, homeTestimonial } from './data';

export const HomeTestimonial: React.FC = () => {
  return (
    <section className="io-home-social" aria-labelledby="io-home-social-quote">
      <div className="io-home-social__inner">
        <div className="io-home-social__quote-block">
          <div className="io-home-social__mark" aria-hidden>
            <span className="io-home-social__mark-bar" />
            <span className="io-home-social__mark-bar" />
          </div>
          <blockquote id="io-home-social-quote" className="io-home-social__quote">
            {homeTestimonial.quote}
          </blockquote>
          <footer className="io-home-social__attrib">
            <div className="io-home-social__avatar-wrap">
              <img
                src={homeTestimonial.image}
                alt=""
                className="io-home-social__avatar"
                width={48}
                height={48}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="io-home-social__who">
              <cite className="io-home-social__name">{homeTestimonial.name}</cite>
              <p className="io-home-social__role">{homeTestimonial.role}</p>
            </div>
          </footer>
        </div>
        <div className="io-home-social__stats">
          {homeStats.map((s) => (
            <div key={s.id} className="io-home-stat">
              <div className="io-home-stat__value">{s.value}</div>
              <div className="io-home-stat__label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
